import React, { Component } from 'react';
import { CallAPI, parseIntFromStr } from '../../utils/util';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import {useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class PastMedicalHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientID: parseIntFromStr(this.props.router.params.patientId),
            history: {
                items: []
            },
        }
        this.getItems = this.getItems.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : ""
    }

    componentDidMount() {
        CallAPI(this.state, `patients/${this.state.patientID}/15/record`, `GET`, (res) => {
            //console.log(res)
            this.setState({history: res})
        })
    }

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.state.patientID} currentStep={2} />}
                    <div className="ci-header">
                        <h2>Past Medical History</h2>
                        <p>Select all conditions that apply to this patient</p>
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="ci-card">
                            <div className="pmh-grid">
                                {this.getItems()}
                            </div>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">
                                Save Changes
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    getItems() {
        return this.state.history.items.map((item, i) => (
            <label key={item.title} className="pmh-option">
                <input
                    type="checkbox"
                    checked={item.value}
                    loc={i}
                    onChange={(e) => this.handleChange(e)}
                />
                <span>{item.title}</span>
            </label>
        ));
    }

    handleChange(e) {
        const target = e.target;
        const {history} = this.state
        const loc = target.getAttribute("loc")
        history.items[loc] = {
            ...history.items[loc],
            "value": target.checked
        }
        this.setState({history});
    }

    handleSubmit(e) {
        e.preventDefault();
        CallAPI([this.state.history], `patients/${this.state.patientID}/record`, 'PUT',
        (res) => {
            if(this.funnel){
                this.props.router.navigate("/patients/"+this.state.patientID+"/familySocialHistory"+this.funnel);
            } else {
                this.setState({
                    "modalVariant": "success",
                    "modalMessage": "Past Medical History has been saved"
                })
            }
        },
        (message) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Past Medical History could not be saved."
            })
        })
    }
}

export default withRouter(PastMedicalHistory)